import {Inject, Injectable} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import {StateService} from './state.service';
import {CoolLocalStorage} from "@angular-cool/storage";

@Injectable({
  providedIn: 'any'
})
export class ApiService {
  host: string;
  protected headers: HttpHeaders;

  constructor(protected http: HttpClient,
              protected state: StateService,
              @Inject('apiModel') public model: string,
              @Inject('apiFormId') public formId: any) {
    this.model = model;
    this.host = environment.apiUrl;
    this.getHeaders();
  }

  protected getHeaders(): HttpHeaders {
    if (!this.formId) {
      this.formId = this.state.formId;
    }
    return new HttpHeaders({
      'Content-Type': 'application/json',
      'X-Form-Id': this.formId,
    });
  }

  public find(filter: any = {}) {
    // console.log('find()', `${this.host}/${this.model}`);
    return this.http.get(`${this.host}/${this.model}?filter=${JSON.stringify(filter)}`, {headers: this.getHeaders()});
  }

  public findById(id: string, filter: any = {}) {
    // console.log('findById()');
    return this.http.get(`${this.host}/${this.model}/${id}?filter=${JSON.stringify(filter)}`, {headers: this.getHeaders()});
  }

  public create(data: any) {
    // console.log('create()');
    return this.http.post(`${this.host}/${this.model}`, data, {headers: this.getHeaders()});
  }

  public update(id: string, data: any) {
    // console.log('update()');
    return this.http.patch(`${this.host}/${this.model}/${id}`, data, {headers: this.getHeaders()});
  }

  public getCustom(path: string, filterOrParams?: any): Observable<any> {
    let params: any = {};

    if (filterOrParams) {
      // Check if this is a filter (for backward compatibility with existing calls)
      // or direct query parameters (for companySettings with loadType and url)
      if (filterOrParams.where || filterOrParams.include || filterOrParams.fields) {
        // This is a filter object, stringify it
        params = { filter: JSON.stringify(filterOrParams) };
      } else {
        // These are direct query parameters (like loadType and url)
        params = filterOrParams;
      }
    }

    return this.http.get<any>(`${this.host}${path}`, {
      headers: this.getHeaders(),
      params
    });
  }


  public postCustom(path: string, data: any): Observable<any> {
    // console.log('postCustom()');
    return this.http.post<any>(`${this.host}${path}`, data, {headers: this.getHeaders()});
  }

  public patchCustom(path: string, data: any): Observable<any> {
    // console.log('patchCustom()');
    return this.http.patch<any>(`${this.host}${path}`, data, {headers: this.getHeaders()});
  }

  public deleteCustom(path: string): Observable<any> {
    return this.http.delete<any>(`${this.host}${path}`, {headers: this.getHeaders()});
  }

  public getCustomUrl(url: string): any {
    var requestOptions = {
      method: 'GET',
    };
    return fetch(url, requestOptions)
      .then(response => {
        return response.json();
      })
      .then(result => {
        return result;
      })
      .catch(error => console.log('error', error));
  }
}
